import React from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from '@mui/material/styles';

const rows = [
  { slNo: 1, description: "Internal Procedure For Change Of Land Use Approval", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20201208_123620.pdf" },
  { slNo: 2, description: "Internal Procedure For Building Planning Approval", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180131_103934.pdf" },
  { slNo: 3, description: "Inspection Procedure And Checklist Of Obtaining Construction Permit", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20210113_155622.pdf" },
  { slNo: 4, description: "Inspection Procedure And Checklist For Obtaining Final Noc", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180131_103141.pdf" },
  { slNo: 5, description: "Procedure And Guidelines For Obtaning Planning Permission On Form 12", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180217_143141.pdf" }, //
  { slNo: 6, description: "Inspection Procedure & Checklist For Obtaning Noc After Construction", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180217_143209.pdf" },
  { slNo: 7, description: "Procedure, Checklist For Obtaning Noc After Construction", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180217_143237.pdf" },
  { slNo: 8, description: "Form/checklist For Sub Division Cases", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20160926_133842.pdf" },
  { slNo: 9, description: "Form/checklist For Registration Of Promoter", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20160926_134232.pdf" },
  { slNo: 10, description: "Form/checklist For Registration Of Estate Agent", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20160926_134350.pdf" },
  { slNo: 11, description: "Form/checklist For License Of Real Estate Projects.",  pdfUrl: "https://tcp.hp.gov.in/Application/img/pdf.png" },
  { slNo: 12, description: "Form/checklist For Completion & Occupation Certificate Of Real Estate Projects. ",  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20150522_080459.docx" },
]
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const FormAndChecklistTable = () => {
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      Form/Checklist
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <StyledTableRow style={{background: '#1F4A7C', height: '20px', color: 'white'}}>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>SL. No</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Headline</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Download</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.slNo}>
              <StyledTableCell component="th" scope="row">
                {row.slNo}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default FormAndChecklistTable;
